export default __webpack_public_path__ + "static/media/faq.b0abb271.svg";